import { RouteOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import CachedIcon from "@mui/icons-material/Cached";
import EditIcon from "@mui/icons-material/Edit";
import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";
import { Box, Button, Chip, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_Row,
  MRT_TableInstance,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/green.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import agent from "../../../../app/api/agent";
import getAxiosError from "../../../../app/api/axiosError";
import { FdpAgent } from "../../../../app/api/fdp/FdpAgent";
import { AddRtsAgent } from "../../../../app/api/rts/AddRtsAgent";
import {
  getEventTypes,
  getRtsPackages,
} from "../../../../app/features/dedicatedDelivery/rtsSlice";
import { getFdpListByClient } from "../../../../app/features/fdp/fdpSlice";
import { updateUserTokenToInvalid } from "../../../../app/features/login/loginSlice";
import {
  RootState,
  useAppDispatch,
} from "../../../../app/features/store/store";
import { FdpResponse } from "../../../../app/models/responseModels/FdpResponse";
import { RtsPackageResponse } from "../../../../app/models/responseModels/rtsPackageResponse";
import GridDataFilter, {
  FilterableColumns,
  FilterableColumnsState,
} from "../../../../components/common/filter/GridDataFilter";
import Loader from "../../../../components/common/loader/Loader";
import {
  useSubmitModal,
  useSubmitModalWithParameter,
} from "../../../../components/common/modalPopup/useSubmitModal";
import { CustomTooltip } from "../../../../components/common/tooltip/CustomToolTip";
import {
  DD_RTS_COLUMN_NAME,
  DD_RTS_LABEL_NAME,
  RtsProps,
  ddRtsGridFilter,
} from "../../DdTypes";
import { getDefaultMRTOptions } from "../../DefaultMrtOptions";
import AddRouteCheckoutModal from "./AddRouteCheckoutModal";
import AddRtsModal from "./AddRtsModal";
import EditRtsModal from "./EditRtsModal";
import styles from "./RtsAdminPanel.styles";
import { format, parse } from "date-fns";
import { title } from "process";

const RtsAdminPanel = (props: RtsProps) => {
  const dispatch = useAppDispatch();
  const defaultMRTOptions = getDefaultMRTOptions<RtsPackageResponse>();
  // const {} = useSelector((state: RootState) => state.fdp);

  const [dateRange, setDateRange] = useState<DateObject[]>([
    new DateObject().setDate(props.startDate),
    new DateObject().setDate(props.endDate),
  ]);
  console.log("Printing props.startDate", props.startDate, "Props.endDate", props.endDate);
  console.log("dateRange", dateRange[0]?.day, dateRange[1]?.day );
  const [filterableColumnsState, setFilterableColumnsState] =
    useState<FilterableColumnsState>({});

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 50,
  });

  const { isRtsLoading, rtsData } = useSelector(
    (state: RootState) => state.rts
  );

  const [serviceLoading, setServiceLoading] = useState<boolean>(false);

  const [dataFetching, setDataFetching] = useState<boolean>(true);

  const [resetFilter, setResetFilter] = useState<boolean>(false);

  const [selectedFdp, setSelectedFdp] = useState<FdpResponse>();

  const clientId = props.clientId;
  const clientName = props.clientName;

  const [addRtsModal, openAddRtsModal] = useSubmitModal((closeAddRtsModal) => (
    <AddRtsModal
      clientIdArg={clientId}
      clientNameArg={clientName}
      closeAddRtsModal={closeAddRtsModal}
      onCompleted={() => {
        fetchRtsData(filterableColumnsState);
      }}
    />
  ));

  const [addRouteCheckout, openAddRouteCheckout] = useSubmitModal(
    (closeRouteCheckoutModal) => (
      <AddRouteCheckoutModal
        clientIdArg={clientId}
        clientNameArg={clientName}
        closeRouteCheckoutModal={closeRouteCheckoutModal}
        onCompleted={() => {
          fetchRtsData(filterableColumnsState);
        }}
      />
    )
  );

  const [editRtsModal, openEditRtsModal] = useSubmitModalWithParameter(
    (row: MRT_Row<RtsPackageResponse>, closeEditRtsModal: CallableFunction) => (
      <EditRtsModal
        row={row}
        fdp={selectedFdp}
        clientIdArg={clientId}
        clientNameArg={clientName}
        closeEditRtsModal={closeEditRtsModal}
        onCompleted={() => {
          fetchRtsData(filterableColumnsState);
        }}
      />
    )
  );

  function formatDates(dateString: string, isUtc: boolean) {
    const formatStr = "YYYY/MM/DD HH:mm:ss";
    if (isUtc) {
      return moment(dateString).utc().format(formatStr);
    } else {
      return moment(dateString).format(formatStr);
    }
  }

  const getValuesByFieldForGridFilter = (
    columnName: string,
    setClFilterableColumns: React.Dispatch<
      React.SetStateAction<FilterableColumns>
    >
  ) => {
    if (columnName) {
      agent.DedicatedDeliveryAgent.getValuesByFieldForRts(
        dateRange[0].format("YYYY-MM-DD"),
        dateRange[1].format("YYYY-MM-DD"),
        columnName,
        clientId
      )
        .then((res) => {
          let resData = res.data;
          console.log(res.data);
          if (res.isSuccess && resData?.length) {
            resData = resData?.map((e) => e.toString());
            setClFilterableColumns((prevState: FilterableColumns) => {
              return {
                ...prevState,
                [columnName]: {
                  ...prevState[columnName],
                  options: resData ?? [],
                },
              };
            });
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(
            "Request is failed while loading options, please try again later."
          );
        });
    }
  };

  const getAllFdpsByClient = useCallback(async () => {
    try {
      const response = await dispatch(getFdpListByClient(clientId)).unwrap();
      if (!response.isSuccess) {
        toast.error(response.message, {
          toastId: "fdpData",
        });
        return;
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "fdpDataException",
      });
    }
  }, [dispatch]);

  const getAssociatedEventTypes = useCallback(async () => {
    try {
      const response = await dispatch(getEventTypes(clientId)).unwrap();
      if (!response.isSuccess) {
        toast.error(response.message, {
          toastId: "clientRtsEventData",
        });
        return;
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "clientRts",
      });
    }
  }, [dispatch]);

  useEffect(() => {
    document.title = "Dedicated Delivery - RTS";
  }, []);

  // ***** Callbacks *****
  const fetchRtsData = useCallback(
    async (filterableColumnsState: FilterableColumnsState) => {
      console.log(pagination.pageIndex, pagination.pageSize);
      try {
        const response = await dispatch(
          getRtsPackages({
            clientId: clientId,
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize,
            startDate: dateRange[0].format("YYYY-MM-DD"),
            endDate: dateRange[1].format("YYYY-MM-DD"),
            filters: filterableColumnsState,
          })
        ).unwrap();
        console.log(response);
        if (!response.isSuccess) {
          toast.error(response.message!, {
            toastId: "rtsData",
          });
        }
      } catch (error) {
        const appError = getAxiosError(error);
        toast.error(appError.errorMessage, {
          toastId: "rtsDataException",
        });
      } finally {
        setDataFetching(false);
        setResetFilter(false);
      }
    },
    [dispatch, pagination, dateRange, clientId]
  );

  // ***** UseEffects *****
  useEffect(() => {
    if (dataFetching) {
      fetchRtsData(filterableColumnsState);
    }
  }, [dataFetching, fetchRtsData, filterableColumnsState]);

  // call to server when user changes page inside grid
  useEffect(() => {
    setDataFetching(true);
  }, [pagination.pageIndex, pagination.pageSize]);

  // Define column definitions for your Material Table
  const columns: MRT_ColumnDef<RtsPackageResponse>[] = [
    {
      accessorKey: DD_RTS_COLUMN_NAME.ID,
      header: DD_RTS_LABEL_NAME.ID,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.ROUTEID,
      header: DD_RTS_LABEL_NAME.ROUTEID,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.USERID,
      header: DD_RTS_LABEL_NAME.USERID,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.USERNAME,
      header: DD_RTS_LABEL_NAME.USERNAME,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.STORENAME,
      header: DD_RTS_LABEL_NAME.STORENAME,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.DATE,
      header: DD_RTS_LABEL_NAME.DATE,
      size: 100,
      Cell: ({ cell, row }) => {
        const rawDate = cell.getValue<string>();
        return format(parse(rawDate, "yyyy-MM-dd", new Date()), "MM/dd/yyyy");
      },
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.REASON,
      header: DD_RTS_LABEL_NAME.REASON,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.BARCODE,
      header: DD_RTS_LABEL_NAME.BARCODE,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.UUID,
      header: DD_RTS_LABEL_NAME.UUID,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.IMAGEURL,
      header: DD_RTS_LABEL_NAME.IMAGEURL,
      size: 100,
      Cell: ({ cell, row }) => (
        <img
          src={row.original?.imageUrl}
          alt={row.original?.imageUrl}
          style={styles.imageThumbnail}
          onClick={() =>
            window.open(
              row.original?.imageUrl,
              "Image(FullScreen)",
              "width=500,height=500"
            )
          }
        />
      ),
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.ISRTSSUBMITTED,
      header: DD_RTS_LABEL_NAME.ISRTSSUBMITTED,
      size: 100,
      Cell: ({row}) => 
        row.original.isRtsSubmitted 
        ? "Yes"
        : "No"
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.EXCEPTIONLATITUDE,
      header: "EXCEPTION COORDINATES",
      size: 100,
      Cell: ({ cell, row }) => (
        <a
          href={`https://maps.google.com/?q=${row.original.exceptionLatitude},${row.original.exceptionLongitude}&z=14`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.exceptionLatitude}, {row.original.exceptionLongitude}
        </a>
      ),
    },
    {
      header: "EXCEPTION SCAN LOCATION",
      Cell: ({ cell, row }) => (
        <>
          <iframe
            title={`https://maps.google.com/?q=${row.original.exceptionLatitude},${row.original.exceptionLongitude}&output=embed&z=14`}
            src={`https://maps.google.com/?q=${row.original.exceptionLatitude},${row.original.exceptionLongitude}&output=embed&z=14`}
            width="150"
            height="150"
            style={{ border: "0" }}
          ></iframe>
        </>
      ),
    },
     {
      accessorKey: DD_RTS_COLUMN_NAME.EXCEPTIONSCANNEDLOCALTIMESTAMP,
      header: DD_RTS_LABEL_NAME.EXCEPTIONSCANNEDLOCALTIMESTAMP,
      size: 100,
      Cell: ({ cell, row }) =>
        row.original.exceptionScanLocalTime
          ? new Date(cell.getValue<string>()).toLocaleString("en-US", {
              hourCycle: "h12",
            })
          : "",
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.RTSLATITUDE,
      header: "RTS COORDINATES",
      size: 100,
      Cell: ({ cell, row }) => (
        <a
          href={`https://maps.google.com/?q=${row.original.rtsLatitude},${row.original.rtsLongitude}&z=14`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.rtsLatitude}, {row.original.rtsLongitude}
        </a>
      ),
    },
    {
      header: "RTS SCAN LOCATION",
      Cell: ({ cell, row }) => (
        <>
          <iframe
            title={`https://maps.google.com/?q=${row.original.rtsLatitude},${row.original.rtsLongitude}&output=embed&z=14`}
            src={`https://maps.google.com/?q=${row.original.rtsLatitude},${row.original.rtsLongitude}&output=embed&z=14`}
            width="150"
            height="150"
            style={{ border: "0" }}
          ></iframe>
        </>
      ),
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.RTSSCANNEDLOCALTIMESTAMP,
      header: DD_RTS_LABEL_NAME.RTSSCANNEDLOCALTIMESTAMP,
      size: 100,
      Cell: ({ cell, row }) =>
        row.original.rtsScanLocalTime
          ? new Date(cell.getValue<string>()).toLocaleString("en-US", {
              hourCycle: "h12",
            })
          : "",
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.SCANTYPE,
      header: DD_RTS_LABEL_NAME.SCANTYPE,
      size: 100,
    },
    // {
    //   accessorKey: DD_RTS_COLUMN_NAME.ACTION,
    //   header: DD_RTS_LABEL_NAME.ACTION,
    //   size: 100,
    // },
    {
      accessorKey: DD_RTS_COLUMN_NAME.CREATEDBY,
      header: DD_RTS_LABEL_NAME.CREATEDBY,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.CREATEDON,
      header: DD_RTS_LABEL_NAME.CREATEDON,
      size: 100,
      Cell: ({ cell, row }) =>
        row.original.createdOn
          ? new Date(cell.getValue<string>()).toLocaleString("en-US", {
              hourCycle: "h12",
            })
          : "",
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.UPDATEDBY,
      header: DD_RTS_LABEL_NAME.UPDATEDBY,
      size: 100,
    },
    {
      accessorKey: DD_RTS_COLUMN_NAME.UPDATEDON,
      header: DD_RTS_LABEL_NAME.UPDATEDON,
      size: 100,
      Cell: ({ cell, row }) =>
        row.original.updatedOn
          ? new Date(cell.getValue<string>()).toLocaleString("en-US", {
              hourCycle: "h12",
            })
          : "",
    },
  ];

  const renderTopToolbarCustomActions = (
    table: MRT_TableInstance<RtsPackageResponse>
  ) => {
    return (
      <Box>
        <CustomTooltip
          arrow
          title="Refresh"
          onClick={() => {
            fetchRtsData(filterableColumnsState);
          }}
        >
          <IconButton type="button">
            <CachedIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>
        <CustomTooltip
          arrow
          title="Add New"
          onClick={() => {
            openAddRtsModal();
            getAllFdpsByClient();
            getAssociatedEventTypes();

            // fetch all data for select
          }}
        >
          <IconButton type="button">
            <AddIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>
        <CustomTooltip arrow title="Export">
          <IconButton
            type="button"
            onClick={() => {
              // if no selection made, then all rows based on date filter is exported.
              setServiceLoading(true);
              if (
                !table.getIsSomeRowsSelected() &&
                !table.getIsAllRowsSelected()
              ) {
                handleExport(undefined);
              } else {
                // if selection made, then all selected rows are exported.
                handleExport(
                  table.getSelectedRowModel().rows.map((row) => row.original.id)
                );
              }
              setServiceLoading(false);
            }}
          >
            <FileDownloadOutlined sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>

        <CustomTooltip arrow title="Route Checkout">
          <IconButton
            type="button"
            onClick={() => {
              openAddRouteCheckout();
              getAllFdpsByClient();
              getAssociatedEventTypes();
            }}
          >
            <RouteOutlined sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>
      </Box>
    );
  };

  const handleExport = async (ids?: number[] | undefined) => {
    try {
      if (dateRange) {
        var formatStartDateP = dateRange[0].format("YYYY-MM-DD");
        var formatEndDateP = dateRange[1].format("YYYY-MM-DD");
        // Send GET request to Spring Boot backend
        const response = await AddRtsAgent.exportCsvData(
          clientId,
          formatStartDateP,
          formatEndDateP,
          filterableColumnsState,
          ids
        );

        // Create a blob from the response data
        const blob = new Blob([response], { type: "text/csv" });

        // Create a download link and trigger click event
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download =
          clientName +
          "-Rts-Package-Report-" +
          formatStartDateP +
          "-to-" +
          formatEndDateP +
          ".csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Cleanup
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      // Handle error
    }
  };

  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    columns: columns,
    data: rtsData.packages,
    manualPagination: true,
    onPaginationChange: setPagination,
    enableRowSelection: true,
    rowCount: rtsData.totalRows,
    initialState: {
      ...defaultMRTOptions.initialState,
    },
    state: {
      pagination,
      showProgressBars: isRtsLoading,
    },

    renderTopToolbarCustomActions: ({ table }) =>
      renderTopToolbarCustomActions(table),
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="body1" component="p">
          Total Rows: {rtsData.totalRows}
        </Typography>
      );
    },

    enableRowActions: true,
    renderRowActions: ({ table, row }) => (
      <>
        <CustomTooltip
          arrow
          title="Edit"
          onClick={() => {
            getAllFdpsByClient();
            getAssociatedEventTypes();
            openEditRtsModal(row);
          }}
        >
          <IconButton type="button">
            <EditIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>
        {/* <CustomTooltip
          arrow
          title="Delete"
          onClick={() => {
            console.log("Delete is clicked");
            openDeleteConfirmModal(row);
          }}
        >
          <IconButton type="button" disabled>
            <DeleteIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip> */}
      </>
    ),
  });

  interface AddRTSRequest {
    userId: string;
    storeId: string;
    barcode: string;
    imageUrl: string;
    latitude: string;
    longitude: string;
    scanLocalTime: string;
    scanType: string;
    action: string;
  }

  return (
    <>
      <Loader isLoading={serviceLoading || dataFetching || isRtsLoading} />
      <Grid container paddingY={2}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography component="h2" variant="h3">
              {clientName} RTS
            </Typography>
          </Grid>
          <Grid item>
            <Grid container item alignItems="center">
              <Box zIndex={100} style={{ overflowY: "auto" }}>
                <DatePicker
                  format="MM/DD/YYYY"
                  className="green"
                  dateSeparator=" ~ "
                  range
                  rangeHover
                  value={dateRange}
                  onChange={(dateObjects: DateObject[]) => {
                    setDateRange(dateObjects);
                  }}
                  maxDate={new Date()}
                />
              </Box>
              <Button
                size="large"
                onClick={() => {
                  setDataFetching(true);
                  setResetFilter(true);
                }}
              >
                SUBMIT
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} marginTop={2}>
            <GridDataFilter
              filterableColumns={ddRtsGridFilter}
              title="Search RTS Data"
              dateRange={dateRange}
              resetFlag={resetFilter}
              asyncSubmitFunction={(filterState: FilterableColumnsState) => {
                console.log(filterState);
                setFilterableColumnsState(filterState);
                fetchRtsData(filterState);
              }}
              asyncSelectedColumnValues={getValuesByFieldForGridFilter}
            />
          </Grid>
          <Grid item xs={12} paddingTop={2}>
            <MaterialReactTable table={table} />
          </Grid>
        </Grid>
      </Grid>
      {addRtsModal}
      {editRtsModal}
      {addRouteCheckout}
    </>
  );
};

export default RtsAdminPanel;
